// extracted by mini-css-extract-plugin
export default {"collection_img":"Collection_collection_img__-F5Tj","collection_img_container":"Collection_collection_img_container__nkkX6"};